module.exports = __webpack_public_path__ + "static/media/porzio_global_spend_transparency_white_logo.4092e30c.png";